const STORAGE_KEY = 'star-snake-sensitivity'
const DEFAULT_SENSITIVITY = 50
const MIN_SENSITIVITY = 10
const MAX_SENSITIVITY = 100

/**
 * Read sensitivity from localStorage and map to a scaling factor.
 * Range 10-100 maps to factor 0.3-2.0 (1.0 at default 50).
 * Low sensitivity (0.3x) = large finger/mouse movement needed.
 * High sensitivity (2.0x) = small movement triggers big turn.
 */
export function getSensitivityFactor(): number {
  const raw = localStorage.getItem(STORAGE_KEY)
  let val = raw !== null ? parseInt(raw, 10) : DEFAULT_SENSITIVITY
  if (isNaN(val)) val = DEFAULT_SENSITIVITY
  val = Math.max(MIN_SENSITIVITY, Math.min(MAX_SENSITIVITY, val))
  return 0.3 + (val - MIN_SENSITIVITY) * (1.7 / (MAX_SENSITIVITY - MIN_SENSITIVITY))
}
